import React from 'react'
import SearchForm from 'components/Search/SearchForm'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import TextLink from 'components/Luxkit/TextLink'
import config from 'constants/config'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import { connect } from 'react-redux'
import { getPeopleLikeMeEntryExperimentVariant } from 'selectors/searchSelectors'

const StyledBodyText = styled(BodyText)`
  padding-top: ${rem(16)};
`

interface MappedStateProps {
  shouldShowPeopleLikeMeEntry: boolean
}

function GlobalHotelsSearchTabContent(props: MappedStateProps) {
  const { shouldShowPeopleLikeMeEntry } = props
  // TODO: restoring these vals is yet to be confirmed with the Search product
  // const {
  //   restoredCheckinDate,
  //   restoredCheckoutDate,
  //   restoredOccupancies,
  //   restoredRecentSearchItems,
  // } = useGlobalSearchRestoreFromStorage()

  const { globalHotelsSearchDispatch, globalHotelsSearchState } = useGlobalHotelsSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
    // checkinDate: restoredCheckinDate,
    // checkoutDate: restoredCheckoutDate,
    // occupancies: restoredOccupancies,
  })

  return <GlobalSearchContextProvider
    state={globalHotelsSearchState}
    dispatch={globalHotelsSearchDispatch}
  >
    <SearchForm
      submitOnApply
    />
    {shouldShowPeopleLikeMeEntry && <StyledBodyText variant="medium">Don't know where to go next? <TextLink to="/people-like-me/inspiration">Get inspired</TextLink></StyledBodyText>}
  </GlobalSearchContextProvider>
}

export default connect<MappedStateProps, undefined, any, App.State>((appState) => {
  const peopleLikeMeExperimentVariant = getPeopleLikeMeEntryExperimentVariant(appState)
  return {
    shouldShowPeopleLikeMeEntry: config.ENABLE_PEOPLE_LIKE_ME_ENTRY && (peopleLikeMeExperimentVariant === '1' || peopleLikeMeExperimentVariant === '2'),
  }
})(GlobalHotelsSearchTabContent)
